<app-card appVisible [visible$]="visible$">
  <div class="d-flex flex-column justify-content-center align-items-center text-center h-100">
    <h5><i class="bi" [class]="icon"></i>{{ title }}</h5>

    @if ((data$ | async) !== undefined && !loading && !error) {
      <div>
        <div class="power-limit-row" [style.color]="colorService.getColor(color)">
          <span>Afname </span>
          <span>
            @if (maxConsumedPowerLimit !== null) {
              {{ maxConsumedPowerLimit | appNumber: unit }} {{ unit }}
            } @else {
              -
            }
          </span>
        </div>
        <div class="power-limit-row" [style.color]="colorService.getColor(color)">
          <span>Teruglevering </span>
          <span>
            @if (maxReturnedPowerLimit !== null) {
              {{ maxReturnedPowerLimit | appNumber: unit }} {{ unit }}
            } @else {
              -
            }
          </span>
        </div>
      </div>
    }

    @if (loading) {
      <div class="container placeholder-glow">
        <span class="value col-12">
          <div class="placeholder"></div>
        </span>
      </div>
    }
    @if (error) {
      <app-error-message [error]="error"></app-error-message>
    }
  </div>
</app-card>
